import React from 'react'
import './Portfolio.css'
import project1 from '../../assets/project1.png';

const Portfolio = () => {
  return (
    <section id="projects">
        <div className="projects-container">
            <h1 className='project-section-title'>Our Projects</h1>

            <div className="project-card-container">
                {Array.from({ length: 6 }).map((_, index) => (
                    <div className="project-card" key={index}>
                        <div className="project-image">
                            <img src={project1} alt={`Project ${index + 1}`} loading='lazy' />
                        </div>
                        <div className="project-info">
                            <span className="project-title">Lead Generation</span>
                            <p className="project-description">
                            </p>
                        </div>
                        <div className="project-buttons">
                            <a href="https://www.fiverr.com/users/smbristy/portfolio/NjJlMGNjZmJiNjJlN2QwMDAxM2Y0MTU3" target='blank' className="green-button">See Project</a>
                            <a href="https://www.fiverr.com/smbristy/generate-targeted-business-leads-and-email-list-at-low-cost" target='blank' className="white-button">View Gig</a>
                        </div>
                    </div>
                ))}
            </div>
        </div>
    </section>
  )
}

export default Portfolio;
